<img class="pp-home__logo" src="assets/images/full-logo.svg" />
